import {isNil} from 'ramda';
import {isNotNilOrEmpty} from 'ramda-adjunct';

import {AuditCategory, AuditStructure, RelatedAction} from '../../../api/digitalCertificateApi';
import {AppLanguage} from '../../../types/AppLanguage';
import {getAuditFieldById} from '../../../utils/getAuditFieldById';
import {getRelatedActionByComparisonKey} from '../../../utils/getRelatedActionByComparisonKey';
import {isCategoryEnabledInAudit} from '../../../utils/isCategoryEnabledInAudit';

type ServiceBookStateParams = {
  relatedActions: RelatedAction[];
  auditCategories: AuditCategory[];
  language: AppLanguage;
  auditStructure: AuditStructure;
};

export const getServiceBookState = (params: ServiceBookStateParams) => {
  const serviceBookTypeRelatedAction = getRelatedActionByComparisonKey(
    'documentationServiceBookType',
    params.relatedActions
  );

  const isEnabledInAudit = isCategoryEnabledInAudit({
    categories: params.auditStructure?.categories ?? [],
    parentUniqueKey: 'VEHICLE_DOCUMENTATION',
    uniqueKey: 'SERVICE_BOOK',
  });

  if (isNil(serviceBookTypeRelatedAction)) {
    return {isEnabledInAudit};
  }

  const selectedTypeValue = getAuditFieldById(
    serviceBookTypeRelatedAction.id,
    params.auditCategories
  )?.value;

  const typeContent = serviceBookTypeRelatedAction.values?.find(
    (v) => v.value === selectedTypeValue
  )?.content;

  const serviceBookStateRelatedAction = typeContent?.relatedActions?.[0] ?? null;

  if (isNil(serviceBookStateRelatedAction)) {
    return {isEnabledInAudit};
  }

  const stateAuditFieldValue = getAuditFieldById(
    serviceBookStateRelatedAction.id,
    params.auditCategories
  )?.value;

  const stateLabel =
    serviceBookStateRelatedAction.values?.find((v) => v.value === stateAuditFieldValue)?.label?.[
      params.language
    ] ?? null;

  const commentRelatedAction = typeContent?.additionalInformation?.find(
    (additionalInformation) => additionalInformation.type === 'additional_comment'
  );

  const commentValue = getAuditFieldById(commentRelatedAction?.id, params.auditCategories)?.value;

  const comment = isNotNilOrEmpty(commentValue) && commentValue !== 'null' ? commentValue : null;

  return {
    value: stateLabel,
    comment,
    isEnabledInAudit,
  };
};
